module.exports = __webpack_public_path__ + "media/garage.ad001b44.svg";